module.exports = __webpack_public_path__ + "static/img/7.b8a0a54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news26/7.jpg
// module id = Whci
// module chunks = 1